import { createLocale } from "./createLocale";

export const hu = createLocale({
  header: {
    title: "Lépj globális szintre. 2 $ / Short. Bármilyen nyelven!",
    subtitle: "🔥Csak az eredményért fizess – $0.089-től $0.009-ig másodpercenként🔥",
  },
  steps: {
    uploadVideo: "Videó feltöltése",
    selectLanguages: "Nyelvek kiválasztása",
    conversionResult: "Konverzió és eredmény",
  },
  upload: {
    dragAndDrop: "Húzza ide a videófájlt",
    orClickToSelect: "vagy kattintson a kiválasztáshoz",
    supportedFormats: "Támogatott formátumok: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Maximális fájlméret: 200 MB",
    maxDuration: "• Maximális időtartam: 30 mp",
    chooseFile: "Fájl kiválasztása",
    selectedFile: "Kiválasztott fájl:",
    size: "Méret:",
    fileTypeError: "Kérjük, válasszon videófájlt",
    fileSizeError: "A fájl mérete ({size} MB) meghaladja a 200 MB-os maximális korlátot",
    durationError: "A videó hossza ({duration} mp) meghaladja a 30 mp-es maximális korlátot",
    fileReadError: "A videófájl nem olvasható. Próbáljon másik fájlt.",
  },
  languages: {
    sourceAudioLanguage: "Forráshang nyelve",
    targetAudioLanguage: "Célhang nyelve",
    selectLanguage: "Válassz nyelvet...",
  },
  conversion: {
    replaceAudio: "Klónozd a hangom",
    uploadVideoAndSelectLanguages: "Tölts fel egy videót, és válassz nyelveket a folytatáshoz",
  },
  nav: {
    blog: "Blog",
  },
  footer: {
    privacyPolicy: "Adatvédelmi irányelvek",
    termsOfUse: "Felhasználási feltételek",
  },
  languageOptions: {
    hu: "Magyar",
  },
});
